import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * ProtectedRoute Component
 * 
 * Wraps routes that require authentication and role-based access
 * Redirects to appropriate auth page if not authenticated
 */
const ProtectedRoute = ({ children, role, isAuthenticated, userData }) => {
  // Check if user is authenticated
  if (!isAuthenticated) {
    // Redirect to role-specific auth page
    if (role === 'rider') {
      return <Navigate to="/rider/auth" replace />;
    } else if (role === 'driver') {
      return <Navigate to="/driver/auth" replace />;
    } else if (role === 'admin') {
      return <Navigate to="/admin/login" replace />;
    }
    // Default: redirect to home
    return <Navigate to="/" replace />;
  }

  // Check if user has correct role
  if (userData && userData.role && userData.role !== role) {
    // User is authenticated but wrong role - redirect to their dashboard
    if (userData.role === 'rider') {
      return <Navigate to="/rider/dashboard" replace />;
    } else if (userData.role === 'driver') {
      return <Navigate to="/driver/dashboard" replace />;
    } else if (userData.role === 'admin') {
      return <Navigate to="/admin/dashboard" replace />;
    }
  }

  // User is authenticated with correct role - render the protected content
  return children;
};

export default ProtectedRoute;
